module.exports = __webpack_public_path__ + "img/cmbs-data-1.15d9dfe3.svg";